import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { config, getEnv } from '../../utils/config';
import { triggerError } from '../../utils/eventManager';
import { getError, PxError } from '../../utils/GqlError';
export { initSession, disposeSession, retryInitSession };
var $id_token = '';
var $access_token = '';
var $email = '';
function initSession(_x, _x2, _x3) {
  return _initSession.apply(this, arguments);
}
/* istanbul ignore next */
function _initSession() {
  _initSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id_token, access_token, email) {
    var err;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          $id_token = id_token;
          $access_token = access_token;
          $email = email;
          _context.prev = 3;
          _context.next = 6;
          return fetch("".concat(config[getEnv()].jerichoUrl, "/auth/_ajax/auth/v1/initsession"), {
            credentials: 'include',
            method: 'post',
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              clientId: 'CHGG',
              tokens: {
                id_token: id_token,
                access_token: access_token
              },
              email: email
            })
          });
        case 6:
          $id_token = '';
          $access_token = '';
          $email = '';
          _context.next = 18;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](3);
          _context.t0.apiName = 'initSession';
          err = getError(_context.t0);
          if (!(err instanceof PxError)) {
            _context.next = 17;
            break;
          }
          throw err;
        case 17:
          triggerError('init session', err);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _initSession.apply(this, arguments);
}
function retryInitSession() {
  return initSession($id_token, $access_token, $email);
}
function disposeSession() {
  return _disposeSession.apply(this, arguments);
}
function _disposeSession() {
  _disposeSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("".concat(config[getEnv()].jerichoUrl, "/auth/_ajax/auth/v1/disposesession"), {
            credentials: 'include',
            method: 'post'
          });
        case 3:
          _context2.next = 8;
          break;
        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          triggerError('dispose session', _context2.t0);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 5]]);
  }));
  return _disposeSession.apply(this, arguments);
}